function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';
import 'snippets/cart-confirmation/cart-confirmation';
import iamotaAjax from 'scripts/helpers/iamota-ajax';
import { cart } from 'scripts/helpers/iamota-shopify-ajax';

// Styles
import './_card.scss';

// variables
var CARD_PRODUCT = '.card--product';
var PRODUCT_CARD = 'iam-product-card';
var CARD_IMAGE_WRAPPER = '.card__image-wrapper';
var CARD_PRODUCT_IMAGE = '.card__product-image';
var CARD_COLOR_OPTION = '.card__swatch--color-option';
var CARD_COLOR_SWATCHES = '.card__color-swatches';
var CARD_CTA_FORM = '.card__cta-form';
var CARD_CTA_BUTTON = '.card__cta--submit';
var CARD_CTA_LABEL = '.card__cta-label';
var CARD_PRIMARY_LINK = '.card__media-link, .card__title-link, .card__cta--link';
var CARD_CONFIRMATION = 'iam-cart-confirmation';
var CARD_CONFIRMATION_ID = 'modal_product_card_confirmation';
var INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, summary, [role="button"], [role="link"]';
var SELECTED_CLASS_NAME = 'selected';
function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function ensureCartConfirmationModal() {
  var _window$translations, _window$translations2;
  var existingModal = document.querySelector(CARD_CONFIRMATION);
  if (existingModal) return existingModal;
  var successMessage = escapeHtml(((_window$translations = window.translations) === null || _window$translations === void 0 ? void 0 : _window$translations.modalSuccessMessage) || 'Added To Your Cart');
  var closeLabel = escapeHtml(((_window$translations2 = window.translations) === null || _window$translations2 === void 0 || (_window$translations2 = _window$translations2.accessibility) === null || _window$translations2 === void 0 ? void 0 : _window$translations2.close) || 'Close');
  document.body.insertAdjacentHTML('beforeend', "\n        <iam-cart-confirmation\n            class=\"modal modal--cart-confirmation\"\n            id=\"".concat(CARD_CONFIRMATION_ID, "\"\n            role=\"dialog\"\n            aria-modal=\"true\"\n            aria-hidden=\"true\"\n        >\n            <div class=\"modal__overlay\"></div>\n            <div class=\"modal__popup\">\n                <div class=\"modal__content\">\n                    <button type=\"button\" class=\"modal__close-button\" aria-label=\"").concat(closeLabel, "\" tabindex=\"-1\">\n                        <svg class=\"icon icon__close\" aria-hidden=\"true\" focusable=\"false\"><use xlink:href=\"#icon-close\"></use></svg>\n                    </button>\n                    <span class=\"cart-confirmation__message\" aria-live=\"polite\">\n                        ").concat(successMessage, " <svg class=\"icon icon__check--circle\" aria-hidden=\"true\" focusable=\"false\"><use xlink:href=\"#icon-check--circle\"></use></svg>\n                    </span>\n                    <div class=\"cart-confirmation__item\" aria-live=\"polite\"></div>\n                    <div class=\"cart-confirmation__content\"></div>\n                </div>\n            </div>\n        </iam-cart-confirmation>\n    "));
  return document.getElementById(CARD_CONFIRMATION_ID);
}
class iamProductCard extends HTMLElement {
  connectedCallback() {
    var _this$addToCartButton;
    this.productUrl = this.dataset.productUrl;
    this.primaryLink = this.querySelector(CARD_PRIMARY_LINK);
    this.addToCartForm = this.querySelector(CARD_CTA_FORM);
    this.addToCartButton = this.querySelector(CARD_CTA_BUTTON);
    this.addToCartLabel = (_this$addToCartButton = this.addToCartButton) === null || _this$addToCartButton === void 0 ? void 0 : _this$addToCartButton.querySelector(CARD_CTA_LABEL);
    // Only the form-based quick-add shows the confirmation modal. The bare
    // button path (cart upsells) updates the cart in place instead.
    this.cartConfirmationModal = this.addToCartForm ? ensureCartConfirmationModal() : null;
    this.isSubmitting = false;
    this.onCardClickRef = this.onCardClick.bind(this);
    this.onCardKeydownRef = this.onCardKeydown.bind(this);
    this.onAddToCartSubmitRef = this.onAddToCartSubmit.bind(this);
    this.addEventListener('click', this.onCardClickRef);
    this.addEventListener('keydown', this.onCardKeydownRef);
    if (this.addToCartForm) {
      this.addToCartForm.addEventListener('submit', this.onAddToCartSubmitRef);
    } else if (this.addToCartButton) {
      // No product form (e.g. cart upsells, where a nested <form> would be
      // invalid HTML) — add to cart via the button's click instead.
      this.onAddToCartClickRef = this.onAddToCartClick.bind(this);
      this.addToCartButton.addEventListener('click', this.onAddToCartClickRef);
    }
  }
  disconnectedCallback() {
    var _this$addToCartForm;
    this.removeEventListener('click', this.onCardClickRef);
    this.removeEventListener('keydown', this.onCardKeydownRef);
    (_this$addToCartForm = this.addToCartForm) === null || _this$addToCartForm === void 0 || _this$addToCartForm.removeEventListener('submit', this.onAddToCartSubmitRef);
    if (this.onAddToCartClickRef) {
      var _this$addToCartButton2;
      (_this$addToCartButton2 = this.addToCartButton) === null || _this$addToCartButton2 === void 0 || _this$addToCartButton2.removeEventListener('click', this.onAddToCartClickRef);
    }
  }
  onCardClick(event) {
    if (!this.productUrl || event.defaultPrevented) return;
    if (event.target instanceof Element && event.target.closest(INTERACTIVE_SELECTOR)) return;
    this.navigateToProduct();
  }
  onCardKeydown(event) {
    if (event.key !== 'Enter' || event.target !== this || !this.productUrl) return;
    event.preventDefault();
    this.navigateToProduct();
  }
  navigateToProduct() {
    var _this$primaryLink;
    var destination = ((_this$primaryLink = this.primaryLink) === null || _this$primaryLink === void 0 ? void 0 : _this$primaryLink.href) || this.productUrl;
    if (destination) {
      window.location.assign(destination);
    }
  }
  onAddToCartSubmit(event) {
    var _this = this;
    return _asyncToGenerator(function* () {
      event.preventDefault();
      if (!_this.addToCartForm || !_this.addToCartButton || _this.isSubmitting) return;
      var requestData = iamotaAjax.formDataToObject(new FormData(_this.addToCartForm));
      var quantity = Number.parseInt(requestData.quantity, 10) || 1;
      requestData.sections = _this.getRequestedSections(requestData.sections);
      _this.setSubmitting(true);
      try {
        var responseData = yield cart.add(requestData);
        _this.openCartConfirmation(responseData, quantity);
      } catch (error) {
        console.error('Unable to add product card item to cart', error);
        if (String((error === null || error === void 0 ? void 0 : error.description) || '').toLowerCase().includes('sold out')) {
          _this.setButtonLabel(_this.addToCartButton.dataset.soldOutLabel);
          _this.addToCartButton.disabled = true;
          _this.addToCartButton.setAttribute('aria-disabled', 'true');
        }
      } finally {
        var _this$addToCartLabel;
        var preserveDisabledState = _this.addToCartButton.disabled && ((_this$addToCartLabel = _this.addToCartLabel) === null || _this$addToCartLabel === void 0 ? void 0 : _this$addToCartLabel.textContent) === _this.addToCartButton.dataset.soldOutLabel;
        _this.setSubmitting(false, preserveDisabledState);
      }
    })();
  }
  onAddToCartClick(event) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      event.preventDefault();
      event.stopPropagation();
      if (!_this2.addToCartButton || _this2.isSubmitting) return;
      var quantity = Number.parseInt(_this2.addToCartButton.dataset.quantity, 10) || 1;
      var requestData = {
        id: _this2.addToCartButton.dataset.variantId,
        quantity
      };
      _this2.setSubmitting(true);
      try {
        yield cart.add(requestData);
        // No confirmation modal here: this button is embedded in the cart
        // (cart upsells). The cart line items + summary refresh via the
        // cart:modified subscribers, and this card removes itself from the
        // upsells once the product is in the cart.
      } catch (error) {
        console.error('Unable to add product card item to cart', error);
        if (String((error === null || error === void 0 ? void 0 : error.description) || '').toLowerCase().includes('sold out')) {
          _this2.setButtonLabel(_this2.addToCartButton.dataset.soldOutLabel);
          _this2.addToCartButton.disabled = true;
          _this2.addToCartButton.setAttribute('aria-disabled', 'true');
        }
      } finally {
        var _this2$addToCartLabel;
        var preserveDisabledState = _this2.addToCartButton.disabled && ((_this2$addToCartLabel = _this2.addToCartLabel) === null || _this2$addToCartLabel === void 0 ? void 0 : _this2$addToCartLabel.textContent) === _this2.addToCartButton.dataset.soldOutLabel;
        _this2.setSubmitting(false, preserveDisabledState);
      }
    })();
  }
  getRequestedSections() {
    var existingSections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var sections = new Set(String(existingSections).split(',').filter(Boolean));
    sections.add('cart-confirmation__item');
    sections.add('cart-confirmation__summary');
    return Array.from(sections).join(',');
  }
  openCartConfirmation(responseData, quantity) {
    var _responseData$section, _responseData$section2;
    var itemHTML = responseData === null || responseData === void 0 || (_responseData$section = responseData.sections) === null || _responseData$section === void 0 ? void 0 : _responseData$section['cart-confirmation__item'];
    var summaryHTML = responseData === null || responseData === void 0 || (_responseData$section2 = responseData.sections) === null || _responseData$section2 === void 0 ? void 0 : _responseData$section2['cart-confirmation__summary'];
    var confirmationModal = this.cartConfirmationModal || ensureCartConfirmationModal();
    if (!(responseData !== null && responseData !== void 0 && responseData.key) || !itemHTML || !summaryHTML || typeof (confirmationModal === null || confirmationModal === void 0 ? void 0 : confirmationModal.openCartConfirmation) !== 'function') {
      console.warn('Unable to open card cart confirmation modal', {
        responseData,
        quantity,
        confirmationModal
      });
      return;
    }
    confirmationModal.openCartConfirmation(responseData.key, quantity, itemHTML, summaryHTML, this.addToCartButton);
  }
  setSubmitting(isSubmitting) {
    var _this$addToCartForm2;
    var preserveDisabledState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.isSubmitting = isSubmitting;
    this.classList.toggle('--submitting', isSubmitting);
    (_this$addToCartForm2 = this.addToCartForm) === null || _this$addToCartForm2 === void 0 || _this$addToCartForm2.classList.toggle('--loading', isSubmitting);
    if (!this.addToCartButton) return;
    if (isSubmitting) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.setAttribute('aria-disabled', 'true');
      this.addToCartButton.setAttribute('aria-busy', 'true');
      this.setButtonLabel(this.addToCartButton.dataset.loadingLabel);
      return;
    }
    this.addToCartButton.setAttribute('aria-busy', 'false');
    this.addToCartButton.disabled = preserveDisabledState;
    this.addToCartButton.setAttribute('aria-disabled', String(preserveDisabledState));
    if (!preserveDisabledState) {
      this.setButtonLabel(this.addToCartButton.dataset.defaultLabel);
    }
  }
  setButtonLabel(label) {
    if (this.addToCartLabel && label) {
      this.addToCartLabel.textContent = label;
    }
  }
}
if (!customElements.get(PRODUCT_CARD)) {
  customElements.define(PRODUCT_CARD, iamProductCard);
}
function changeSwatch(swatchOption) {
  // Update selected state
  if (!swatchOption.classList.contains(SELECTED_CLASS_NAME)) {
    swatchOption.closest(CARD_COLOR_SWATCHES).querySelector(".".concat(SELECTED_CLASS_NAME)).classList.remove(SELECTED_CLASS_NAME);
    swatchOption.classList.add(SELECTED_CLASS_NAME);
    var newImageSrc = swatchOption.dataset.imageSrc;
    if (newImageSrc !== undefined) {
      // Get additional src and srcset
      var newDesktopMedia = swatchOption.dataset.desktopMedia;
      var newDesktopSrcset = swatchOption.dataset.desktopSrcset;
      var newMobileSrcset = swatchOption.dataset.mobileSrcset;
      var newImageSrcset = swatchOption.dataset.imageSrcset;
      var productCard = swatchOption.closest(CARD_PRODUCT);
      var productCardImageWrapper = productCard.querySelector(CARD_IMAGE_WRAPPER);
      var productCardPicture = productCardImageWrapper.querySelector('picture');
      var productCardPictureImage = productCardPicture.querySelector(CARD_PRODUCT_IMAGE);

      // Update desktop and mobile src
      productCardPicture.querySelectorAll('source').forEach((source, index) => {
        switch (index) {
          case 0:
            // Desktop Source
            source.media = newDesktopMedia;
            source.srcset = newDesktopSrcset;
            break;
          case 1:
            // Mobile Source
            source.srcset = newMobileSrcset;
            break;
          default:
            break;
        }
      });

      // Update image src
      productCardPictureImage.src = newImageSrc;
      productCardPictureImage.srcset = newImageSrcset;
    }
  }
}
document.querySelectorAll(CARD_COLOR_OPTION).forEach(element => {
  element.addEventListener('click', element => {
    element.stopPropagation();
    var selectedSwatchOption = element.currentTarget;
    changeSwatch(selectedSwatchOption);
  });
  element.addEventListener('keydown', element => {
    element.stopPropagation();
    if (element.key === 'Enter') {
      var selectedSwatchOption = element.currentTarget;
      changeSwatch(selectedSwatchOption);
    }
  });
});